import React from 'react';
import AppLayout from './AppLayout';
import MyPiggyIcon from '../UI/MyPiggyIcon';
import '../../styles/brand-typography.css';
import './ParentAccountLayout.css';

// Presentation wrapper: account recovery, invitation and setup handlers stay in their pages.
export default function ParentAccountLayout({ children, className = '', ...props }) {
  return (
    <AppLayout {...props} className={`mypiggy-brand parent-account ${className}`}>
      <div className="mx-auto mb-4 flex max-w-lg items-center justify-center gap-2 text-teal-900 dark:text-teal-200">
        <MyPiggyIcon name="my-piggy-bank" size="sm" />
        <span className="text-lg font-extrabold">MyPiggy Parents</span>
      </div>
      {children}
    </AppLayout>
  );
}
